import Event from '../../core/Event';
import { Location } from 'history';

export default class UserNotAuthorized extends Event {
    public static type = 'UserNotAuthorized';

    constructor(public readonly initialLocation: Location) {
        super(UserNotAuthorized.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/user/events/UserNotAuthorized.ts